module.exports = __webpack_public_path__ + "img/13.e0b02286.jpg";